import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { MARKETING_HUB_BASIC } from 'self-service-api/constants/ApiNames';
import { TALK_TO_SALES_FALLBACK } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { MARKETING_PRO } from 'self-service-api/constants/UpgradeProducts'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import UIContactSalesButton from 'ui-addon-upgrades/button/UIContactSalesButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import { isUngatedSelector } from '../../selectors/GatingSelectors';
import { hasProductInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { talkToSalesTypeSelector } from '../../selectors/PurchaseMotionSelectors';

const BasicPromoBanner = ({
  promoKey,
  contactIsc
}) => /*#__PURE__*/_jsxs(UIAlert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `pricingPage.promotions.marketingBasicPromoBanner.${promoKey}.title`
  }),
  type: "info",
  "data-selenium": `${promoKey}-basic-promo-banner`,
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: `pricingPage.promotions.marketingBasicPromoBanner.${promoKey}.body`
  }), /*#__PURE__*/_jsx(UILink, {
    className: "m-left-2",
    external: true,
    href: "https://legal.hubspot.com/marketing-basic-upgrade-terms",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.promotions.marketingBasicPromoBanner.promotionDetails"
    })
  }), /*#__PURE__*/_jsx(UIContactSalesButton, {
    isAssignable: !contactIsc,
    className: "m-left-4",
    size: "small",
    use: "tertiary",
    upgradeData: {
      app: 'pricing-pages',
      screen: 'marketing',
      upgradeProduct: MARKETING_PRO,
      uniqueId: `basic-promo-${promoKey}`
    }
  })]
});

const MarketingBasicPromoBanner = ({
  productLine
}) => {
  const isUngatedForHalfOff = useSelector(state => isUngatedSelector(state, {
    gateKey: 'Growth:MarketingBasicPromoHalfOff'
  }));
  const isUngatedForSamePrice = useSelector(state => isUngatedSelector(state, {
    gateKey: 'Growth:MarketingBasicPromoSamePrice'
  }));
  const ttsPurchaseMotion = useSelector(talkToSalesTypeSelector);
  const hasMarketingBasic = useSelector(state => hasProductInProductInventorySelector(state, {
    productAttributeFilters: {
      apiName: MARKETING_HUB_BASIC
    }
  }));
  if (productLine !== MARKETING) return null;
  if (!hasMarketingBasic) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isUngatedForHalfOff && /*#__PURE__*/_jsx(BasicPromoBanner, {
      contactIsc: ttsPurchaseMotion === TALK_TO_SALES_FALLBACK,
      promoKey: "halfOff"
    }), isUngatedForSamePrice && /*#__PURE__*/_jsx(BasicPromoBanner, {
      contactIsc: ttsPurchaseMotion === TALK_TO_SALES_FALLBACK,
      promoKey: "samePrice"
    })]
  });
};

export default MarketingBasicPromoBanner;